const namespace = {
  sidebar: {
    header: {
      title: "Catégories",
      backAction: "Retour au menu",
      toggle: {
        ariaLabel: "Basculer le menu des scores",
        ariaLabel_open: "Ouvrir le menu des scores",
        ariaLabel_close: "Fermer le menu des scores",
      },
    },
  },
  categoriesToggle: {
    toggleLabel: "Catégories",
    backAction: "Retour",
  },
  categories: {
    commute: "Transport",
    amenities: "Services",
    character: "Caractère",
    nature: "Nature",
    education: "Éducation",
    health: "Santé",
  },
  scoreComparison: {
    text: "Comparable à la moyenne de {{name}} de {{value}}",
    text_higher: "Supérieur à la moyenne de {{name}} de {{value}}",
    text_lower: "Inférieur à la moyenne de {{name}} de {{value}}",
  },
  poiSearchRadius: "Affichage des PO dans un rayon de {{radius}} {{unit}}",
  commute: {
    placeholder: "Faire une recherche...",
    cta: "Calculer le trajet",
    cta_long: "Calculer le trajet",
    cta_short: "Calculer",
    viewRoute: "Voir l'itinéraire",
    travelTypes: {
      walking: "À pied",
      driving: "En voiture",
      cycling: "À vélo",
    },
    results: {
      noRoute: "Aucun itinéraire disponible.",
      trySuggestion: "Essayez une autre requête.",
      fastestRoute: "Itinéraire le plus rapide",
    },
  },
} as const;

export default namespace;
